export enum Form1099Warning {
    NAME_UNVERIFIED = "name_unverified",
    MISSING_ADDRESS = "missing_address",
    MISSING_CLASSIFICATION = "missing_classification",
    LIKELY_EXEMPT_CORPORATION = "likely_exempt_corporation",
}

export enum Track1099FederalIdType {
    INDIVIDUAL = 5,
    BUSINESS = 6,
    UNKNOWN = 7,
}
